import React from 'react'
import { Box, makeStyles, Typography } from '@material-ui/core'
import clsx from 'clsx'
import { t } from 'i18next'
import { NavItem } from 'components/Sidebar/components/nav-item'

const useStyles = makeStyles(theme => ({
  groupContainer: {
    'width': '100%',
    'position': 'relative',
    'margin': theme.spacing(0, 0, 1),
    'color': theme.palette.grey.main,
  },
  groupLabel: {
    fontSize: 10,
    textTransform: 'uppercase',
    paddingLeft: theme.spacing(4),
    fontWeight: theme.typography.fontWeightMedium,
  },
  separator: {
    height: 2,
    borderRadius: 4,
    width: theme.spacing(3),
    margin: theme.spacing(2, 'auto'),
    backgroundColor: theme.palette.grey.main,

  }
}))

export const NavGroup = ({ group, sidebarOpen }) => {
  const classes = useStyles()

  return (
    <Box sx={{ width: '100%' }}>
      {sidebarOpen ?
        (
          <div className={classes.groupContainer}>
            <Typography className={classes.groupLabel}>
              {t(group.groupLabel)}
            </Typography>
          </div>
        ) :
        (
          <div className={classes.separator} />
        )}

      <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column' }}>
        {group.items.map(navItem => (
          <NavItem
            sidebarOpen={sidebarOpen}
            item={navItem}
            key={navItem.label}
          />
        ))}
      </Box>
    </Box>
  )
}
